import { useGqlQuery } from 'src/hooks/use-gql-query';
import query from './query.graphql';
import type {
  PriceHistorySummaryQuery,
  PriceHistorySummaryQueryVariables,
} from 'types';

export function usePriceHistorySummaryQuery(
  variables: PriceHistorySummaryQueryVariables
) {
  return useGqlQuery<PriceHistorySummaryQuery>({
    queryKey: ['product', 'priceHistorySummary'],
    query,
    variables,
  });
}
